const USER_ATTRIBUTES = {
  id: "modules/analytics/schema/userAttributes",
  type: "object",
  properties: {
    user_email: {
      type: "string",
      format: "email",
    },
    user_name: {
      type: "string",
    },
    user_email_verified: {
      type: "boolean",
    },
    user_phone_number: {
      type: "string",
    },
    user_phone_verified: {
      type: "boolean",
    },
    user_gender: {
      type: "string",
    },
    user_home_city: {
      type: "string",
    },
    user_home_state: {
      type: "string",
    },
    user_home_country: {
      type: "string",
    },
    user_company_name: {
      type: "string",
    },
    user_job_role_title: {
      type: "string",
    },
    user_company_join_date: {
      type: "string",
    },
    user_fixed_ctc: {
      type: "number",
    },
    user_ctc_currency: {
      type: "string",
    },
    user_months_of_experience: {
      type: "number",
    },
    user_skills_proficiency: {
      type: "array",
    },
    mentee_job_search_status: {
      type: "string",
    },
    user_college_name: {
      type: "string",
    },
    user_degree: {
      type: "string",
    },
    user_degree_branch: {
      type: "string",
    },
    user_graduation_year: {
      type: "number",
    },
    user_registration_date: {
      type: "string",
    },
    mentee_sales_punch_date: {
      type: "string",
      format: "date-time",
    },
    mentee_first_payment_date: {
      type: "string",
      format: "date-time",
    },
    mentee_status: {
      type: "string",
    },
    mentee_is_paid: {
      type: "boolean",
    },
    mentee_onboarded_super_batch: {
      type: "string",
    },
    mentee_course_title: {
      type: "string",
    },
    mentee_course_region: {
      type: "string",
    },
    mentee_super_batch: {
      type: "string",
    },
    mentee_last_paused_date: {
      type: "string",
      format: "date-time",
    },
    mentee_last_resume_date: {
      type: "string",
      format: "date-time",
    },
    mentee_total_problem_solved: {
      type: "number",
    },
    mentee_psp: {
      type: "number",
    },
    mentee_attendance: {
      type: "number",
    },
    mentee_referred_by_code: {
      type: "string",
    },
    user_scaler_referral_code: {
      type: "string",
    },
    mentee_degree_enrollment_status: {
      type: "string",
    },
  },
}

export default USER_ATTRIBUTES
